export default [
  {
    path: "/customer",
    name: "customer",
    meta: {title: "My-Customer"},
    component: () => import("../views/customer/user/customer-list.vue")
  },
  {
    path: "/customer/:seId/:mlId",
    name: "customer-view",
    meta: {title: "My-Customer-View"},
    component: () => import("../views/se/view/se-view.vue")
  },
  {
    path: "/customer/crp",
    name: "customer-crp",
    meta: {title: "CRP-Customer-List"},
    component: () => import("../views/customer/admin/crp-customer-list.vue")
  },
  {
    path: "/customer/scicom",
    name: "customer-scicom",
    meta: {title: "SciCom-Customer-List"},
    component: () => import("../views/customer/admin/scicom-customer-list.vue")
  },
  {
    path: "/customer/cveo",
    name: "customer-cveo",
    meta: {title: "CVEO-Customer-List"},
    component: () => import("../views/customer/admin/cveo-customer-list.vue")
  },
  {
    path: "/customer/clin-trans",
    name: "customer-clin-trans",
    meta: {title: "Clin-trans-Customer-List"},
    component: () => import("../views/customer/admin/clin-trans-customer-list.vue")
  },
]